<script lang="ts">import { Checkbox } from "@infinitro/checkbox";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import { stateAuthTab, stateTermsConfirmed } from "../state";
let _element;
const onCheck = ({ checked }) => stateTermsConfirmed.set(checked);
$: usesDirectAuth = $stateAuthTab.usesDirectAuth;
</script>

<span class="section" class:section-notice={usesDirectAuth}>
	{#if usesDirectAuth}
		<p class="notice">
			{$t(Verbiage.create_account_terms_notice)}
			<a
				class="terms-link"
				href={toSiteUrl('/terms-of-service/', $loggedIn)}
				target="_blank"
				rel="noopener noreferrer"
			>
				{$t(Verbiage.terms_and_conditions)}
			</a>
		</p>
	{:else}
		<span class="terms">
			<span class="input-container">
				<Checkbox
					id="confirmAgeCheckbox"
					label={$t(Verbiage.confirm_age_terms)}
					checked={$stateTermsConfirmed}
					onChange={onCheck}
				/>
			</span>
		</span>
	{/if}
</span>

<style>
	.section {
		display: flex;
		flex-direction: column;
		align-items: baseline;
		padding-bottom: 0.5rem;
}
	.section-notice {
		width: 100%;
		padding-bottom: 0px;
}
	.input-container {
		display: flex;
		align-items: center;
		padding: 0.5rem;
}
	@media (min-width: 640px) {
		input {
				height: 1.25rem;
				width: 1.25rem;
		}
	}
	.terms {
		display: flex;
		flex-direction: row;
		align-items: center;
		vertical-align: middle;
		font-size: 0.7rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.notice {
		width: 100%;
		text-align: center;
		font-size: 12px;
		line-height: 1rem;
		color: var(--color-text-500);
}
	.terms-link {
		color: var(--color-text-100);
		text-decoration-line: underline;
}
	:global(.custom-checkbox-text) {
		font-size: 12px !important;
	}
	:global(.custom-checkbox-text *) {
		font-size: 12px !important;
	}
</style>
